import React from 'react'
import findIndex from 'lodash/findIndex'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss'
import 'swiper/components/navigation/navigation.scss'
import { PhotoType } from '../../store/commonTypes'
import { switchMenu } from '../../store/common/commonSlice'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

interface Props {
    list: PhotoType[]
    photo: PhotoType
}

SwiperCore.use([Navigation])

const SwiperNotLoggined: React.FunctionComponent<Props> = ({ list, photo }: Props) => {
    const [t] = useTranslation()
    const dispatch = useDispatch()
    return (
        <Swiper navigation initialSlide={findIndex(list, photo)} className="mySwiper">
            {list.map((item) => (
                <SwiperSlide key={item.id}>
                    <img className="photo_blur" src={item.thumbnail_url} alt="" />
                    <div className="content-no-xxl-member">
                        {/*<p>{t('Log in', { context: 'action' })}</p>*/}
                        {/*<p>{t('to open this photo')}</p>*/}
                        <p>{t('Please log in to view this photo')}</p>
                        <button
                            className="login-button"
                            onClick={() => {
                                dispatch(switchMenu())
                            }}
                        >
                            {t('Log in')}
                        </button>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default SwiperNotLoggined
